import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { GET_RECOMMENDATIONS, getRecommendationsUrl, getRecommendationB2bDetailsUrl, GET_RECOMMENDATIONS_B2B_DETAILS, headers, GET_ALL_RECOMMENDATIONS, getAllRecommendationsUrl, INSERT_B2B_MEETING, insertB2bMeetingUrl } from "../../../utils/constants";


export const getRecommendation_action = (DelegateRegistrationID, TypeID, ChapterName, CompanyName, CountryName) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            RegistrationID: DelegateRegistrationID,
            TypeID: TypeID,
            ChapterName: ChapterName,
            CompanyName: CompanyName,
            CountryName: CountryName,
        }
        console.log("getVisitorDashboard_action Action------->", params)

        const res = await axiosGet(getRecommendationsUrl, params, headers)

        dispatch({
            type: GET_RECOMMENDATIONS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getAllRecommendation_action = (DelegateRegistrationID, TypeID, ChapterName, CompanyName, CountryName) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            RegistrationID: DelegateRegistrationID,
            TypeID: TypeID,
            ChapterName: ChapterName,
            CompanyName: CompanyName,
            CountryName: CountryName,
        }
        console.log("getVisitorDashboard_action Action------->", params)

        const res = await axiosGet(getAllRecommendationsUrl, params, headers)

        dispatch({
            type: GET_ALL_RECOMMENDATIONS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getRecommendationB2bDetails_action = (B2BBookedByTypID, B2BBookedByRegID, B2BBookedToTypID, B2BBookedToRegID) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            B2BBookedByTypID: B2BBookedByTypID,
            B2BBookedByRegID: B2BBookedByRegID,
            B2BBookedToTypID: B2BBookedToTypID,
            B2BBookedToRegID: B2BBookedToRegID,

            // ChapterName: ChapterName
        }
        console.log("getVisitorDashboard_action Action------->", params)

        const res = await axiosGet(getRecommendationB2bDetailsUrl, params, headers)

        dispatch({
            type: GET_RECOMMENDATIONS_B2B_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertB2bMeeting_action = (B2BBookedByTypID, B2BBookedByRegID, B2BBookedToTypID, B2BBookedToRegID, Remark, B2bTimeSlotList) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            B2BBookedByTypID: B2BBookedByTypID,
            B2BBookedByRegID: B2BBookedByRegID,
            B2BBookedToTypID: B2BBookedToTypID,
            B2BBookedToRegID: B2BBookedToRegID,
            exhibitionName: sessionStorage.getItem("ExhibitionName"),
            // MeetingDate: MeetingDate,
            // B2BTimeSlotID: B2BTimeSlotID,
            Remark: Remark,
            B2bTimeSlotList: B2bTimeSlotList
            // ChapterName: ChapterName
        }
        console.log("getVisitorDashboard_action Action------->", params)

        const res = await axiosPost(insertB2bMeetingUrl, params, headers)

        dispatch({
            type: INSERT_B2B_MEETING,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}